var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-score-confirm-value"},[(_vm.hasValue)?_c('span',{class:['value', _vm.getState]},[_vm._v(_vm._s(_vm.value))]):_c('span',{staticClass:"empty"},[_vm._v(_vm._s(_vm.emptyText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }